import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export function GalleryPlaceholder() {
  const ref = useRef<HTMLBodyElement | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.querySelector('body');
    setMounted(true);
  }, []);

  return mounted
    ? createPortal(
        <div className="bg-white dark:bg-black fixed bottom-0 top-0 left-0 right-0 flex items-center justify-center">
          <div className="rounded-full w-8 h-8 bg-darkPink animate-ping" />
        </div>,
        ref.current,
      )
    : null;
}
